import styled from "styled-components";

export const SpaceParent = styled.div`
  height:80px;    
  @media(min-width: 768px) {  
    height:160px;    
  }
`